import intl from "react-intl-universal";
import {
  TbAdjustmentsHorizontal,
  TbBuildingBank,
  TbCreditCard,
  TbHash,
} from "react-icons/tb";
import { ModernFilterBar } from "../../../../../Components/Molecules/Filters/ModernFilterBar";
import { CheckboxListFilterPanel } from "../../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_BAAS_CARD_ACCOUNTS_FILTERS,
  buildBaasCardAccountsFilterTags,
  getBaasCardAccountLinkedOptions,
  getBaasCardAccountProductOptions,
  getBaasCardAccountProgramOptions,
  getBaasCardAccountStatusOptions,
  hasActiveBaasCardAccountsFilters,
  isBaasCardAccountsChipFilterActive,
  removeBaasCardAccountsFilterTag,
} from "../baasCardAccountsFilters";

export const BaasCardAccountsFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems = [],
  accounts = [],
}) => {
  const source = accounts.length ? accounts : filteredItems;
  const programOptions = getBaasCardAccountProgramOptions(source);
  const productOptions = getBaasCardAccountProductOptions(source);

  const filterButtons = [
    {
      id: "status",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("baas.cartoes.accounts.filters.status"),
      active: isBaasCardAccountsChipFilterActive(filters, "status"),
    },
    {
      id: "program",
      icon: TbCreditCard,
      label: intl.get("baas.cartoes.accounts.filters.program"),
      active: isBaasCardAccountsChipFilterActive(filters, "program"),
    },
    {
      id: "product",
      icon: TbHash,
      label: intl.get("baas.cartoes.accounts.filters.product"),
      active: isBaasCardAccountsChipFilterActive(filters, "product"),
    },
    {
      id: "linked",
      icon: TbBuildingBank,
      label: intl.get("baas.cartoes.accounts.filters.linked"),
      active: isBaasCardAccountsChipFilterActive(filters, "linked"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "status":
        return (
          <CheckboxListFilterPanel
            options={getBaasCardAccountStatusOptions()}
            selectedValues={draft.statuses}
            onChange={(statuses) => onChange({ ...draft, statuses })}
            idPrefix="baas-card-accounts-status"
          />
        );
      case "program":
        return (
          <CheckboxListFilterPanel
            options={programOptions}
            selectedValues={draft.programIds}
            onChange={(programIds) => onChange({ ...draft, programIds })}
            idPrefix="baas-card-accounts-program"
            searchable={programOptions.length > 8}
          />
        );
      case "product":
        return (
          <CheckboxListFilterPanel
            options={productOptions}
            selectedValues={draft.productCodes}
            onChange={(productCodes) => onChange({ ...draft, productCodes })}
            idPrefix="baas-card-accounts-product"
          />
        );
      case "linked":
        return (
          <CheckboxListFilterPanel
            options={getBaasCardAccountLinkedOptions()}
            selectedValues={draft.linkedStates}
            onChange={(linkedStates) => onChange({ ...draft, linkedStates })}
            idPrefix="baas-card-accounts-linked"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_BAAS_CARD_ACCOUNTS_FILTERS}
      searchPlaceholder={intl.get("baas.cartoes.accounts.filters.searchPlaceholder")}
      filterButtons={filterButtons}
      buildFilterTags={(currentFilters) =>
        buildBaasCardAccountsFilterTags(currentFilters, source)
      }
      hasActiveFilters={hasActiveBaasCardAccountsFilters}
      removeFilterTag={removeBaasCardAccountsFilterTag}
      renderPanelContent={renderPanelContent}
      filteredItems={filteredItems}
      panelTitles={{
        status: intl.get("baas.cartoes.accounts.filters.status"),
        program: intl.get("baas.cartoes.accounts.filters.program"),
        product: intl.get("baas.cartoes.accounts.filters.product"),
        linked: intl.get("baas.cartoes.accounts.filters.linked"),
      }}
    />
  );
};
